import { render, staticRenderFns } from "./business-school.vue?vue&type=template&id=0d0ea07a"
import script from "./business-school.vue?vue&type=script&lang=ts"
export * from "./business-school.vue?vue&type=script&lang=ts"
import style0 from "./business-school.vue?vue&type=style&index=0&id=0d0ea07a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports